module.exports = __webpack_public_path__ + "static/media/Cater.b42de96b.jpg";